import React from "react";
import '../../assets/css/index.css';
import Header from "../../components/Header";

const PrivacyPolicies = () => {

    return (
        <div className="main-box">
            <div className="waitlist" style={{ backgroundColor: "#000000", zIndex: 999, width: '100%' }}>
                <Header />
            </div>
            <div className="container">
                <h1 className="heading">Privacy Policy</h1>
                <div className="sections">
                    <h4 className="sub-heading">Privacy Policy for Starnex Network Pvt Ltd</h4>
                    <p className="main-para"> 
                        At Starnex Network Pvt Ltd, safeguarding your privacy is a priority. This Privacy Policy outlines how we collect, use, share, and protect your information when you use our services or products, including our website and mobile application. By accessing or using our application, website, products, or services, you signify your acceptance of this Privacy Policy. If you do not agree with the terms of this Privacy Policy, please do not use our application, website, products, or services Information Collection and Use
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <h4 className="sub-heading">We collect various types of information to provide and enhance our services:</h4>
                    <p className="main-para">
                        <strong className="para-head">Personal Information: </strong>
                        This includes details such as your name, email address, contact information, location, and any data voluntarily provided during registration, account creation, or communication with us.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Account Information: </strong>
                        settings, usage patterns, and transactional data linked to your account.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Communication Data: </strong>
                        Correspondence, messages, feedback, and interactions with our support team or other users.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Usage Data: </strong>
                        activities, device details, IP address, cookies, and analytics data.
                    </p>
                </div>
                
                <div className="divider" />
                <div className="sections">
                    <h4 className="sub-heading">How We Use Your Data</h4>
                    <p className="main-para">
                        We utilize your personal information for various purposes, including:
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Service Provision:</strong> Managing and customizing your account, providing platform access, and delivering tailored content and features.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Support and Communication:</strong>{' '} Responding to your inquiries, offering customer support, sending service-related communications, updates, and notifications.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Security and Compliance:</strong>{' '} Ensuring platform security, user safety, and compliance with legal obligations.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Improvement and Analytics:</strong>{' '} Analyzing usage patterns, conducting research, and using insights to enhance services, develop new features, and improve user experience.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <h4 className="sub-heading">Sharing of Information</h4>
                    <p className="main-para">
                        We may share your personal information in the following scenarios:
                    </p>
                    <p className="main-para">
                        <strong className="para-head">With Consent:</strong> Sharing with your explicit consent or as necessary to provide requested services.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Service Providers:</strong> Sharing with trusted partners, service providers, or affiliates supporting service delivery, maintenance, or improvement.
                    </p>
                    <p className="main-para">
                        <strong className="para-head">Legal Compliance:</strong> Sharing to comply with Indian laws, regulations, legal obligations, respond to legal requests, or protect our rights.
                    </p>
                    <div className="ContentBox">
                        <h4 className="title">Data Security:</h4>
                        <div className="listStyle">
                            <h5 className="list-num-2">{'\u2022'}</h5>
                            <p className="main-para">
                                We implement reasonable security measures to protect your personal information from unauthorised access, alteration, disclosure, or destruction.
                            </p>
                        </div>
                        <div className="listStyle">
                            <h5 className="list-num-2">{'\u2022'}</h5>
                            <p className="main-para">
                                However, no method of transmission or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Your Privacy Rights and Choices </div>
                    <p className="main-para">
                        You have the right to access, update, or delete your personal information. Manage your privacy settings through the app or by contacting us.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Data Retention </div>
                    <p className="main-para">
                        We retain personal information as long as needed to fulfil outlined purposes or as required by applicable laws.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> International Data Transfers </div>
                    <p className="main-para">
                        Your data may be transferred, stored, or processed in India or other countries in compliance with Indian data protection laws.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Children&apos;s Privacy </div>
                    <p className="main-para">
                        We do not knowingly collect personal information from children without parental consent in accordance with Indian laws and regulations.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Additional Provisions for Indian Users </div>
                    <p className="main-para">
                        Indian users may have specific privacy rights under local laws. We respect these rights and process requests in accordance with applicable regulations.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Links to Other Websites </div>
                    <p className="main-para">
                        WeOur Privacy Policy applies only to our services. External website links are not governed by our policy; review  privacy policies separately.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Changes to the Privacy Policy </div>
                    <p className="main-para">
                        We reserve the right to update or modify this Privacy Policy. Any changes will be reflected on this page; review it periodically.
                    </p>
                </div>
                <div className="divider" />
                <div className="sections">
                    <div className="sub-heading"> Contact Us </div>
                    <p className="main-para">
                        For questions, concerns, or requests regarding this Privacy Policy or our handling of your personal, contact us at:{' '} <a className="link-text" href="mailto:info@starnex.co">info@starnex.co</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicies;